import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, wait } from 'ngx-core-services';
import { UiPromiseService } from 'ngx-zcs-components';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'customer-login',
  templateUrl: './custom-login.component.html',
  styleUrls: ['./custom-login.component.scss'],
})
export class CustomLoginComponent {
  emulator = environment.emulator;
  inCorse = false;
  readonly isSignWithAppleAvailable = ['ios', 'web'].includes(Capacitor.getPlatform());
  readonly token = new FormControl('');

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly uiPromiseService: UiPromiseService,
    private readonly translateService: TranslateService,
    private readonly router: Router,
  ) {
    this.loginWithCustomToken = this.loginWithCustomToken.bind(this);
  }

  async loginWithCustomToken() {
    const token = this.token.value;
    if (!token) {
      return;
    }

    if (this.inCorse) {
      return;
    }

    this.inCorse = true;
    await this.uiPromiseService.run(async () => {
      await this.authenticationService.loginWithCustomToken(token);
      await this.router.navigate(['/']);
      await wait(2000);
    }, {
      loading: true,
    });
    this.inCorse = false;
  }

  async signUpWithApple() {
    if (this.inCorse) {
      return;
    }

    this.inCorse = true;
    await this.uiPromiseService.run(async () => {
      await this.authenticationService.signUpWithApple();
      await this.router.navigate(['/']);
      await wait(2000);
    }, {
      loading: true,
      loadingMessage: this.translateService.instant('i18n.LoginService.appleSigningIn'),
    });
    this.inCorse = false;
  }

  async signUpWithGoogleWeb() {
    if (this.inCorse) {
      return;
    }

    this.inCorse = true;

    await this.uiPromiseService.run(async () => {
      const userCredential = await this.authenticationService.loginWithGoogle();
      if (userCredential) {
        await this.router.navigate(['/']);
        await wait(2000);
      }
    }, {
      loading: true,
      loadingMessage: this.translateService.instant('i18n.LoginService.googleSigningIn'),
    });

    this.inCorse = false;
  }
}
